import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonUtil } from '../../core/Utils/common-util';
import { SafeHtml } from '@angular/platform-browser';

import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { MustMatch } from '../helpers/must-match.validator';
import { PasswordPolicy } from '../helpers/password.policy.validator';
import { ValidateManagerEmailService } from '../../pre-login/services/validate-manager-email.service';
import { Router } from '@angular/router';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FacilityMaintainanceUserDetailsObject } from '../../core/services/facility.model';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

interface IManagerEmail{
  email: string ;
}

@Component({
  selector: 'app-sign-up-basic-information',
  templateUrl: './sign-up-basic-information.component.html',
  styleUrls: ['./sign-up-basic-information.component.css'],
})
export class SignUpBasicInformationComponent implements OnInit {
  @Input() userInformation: FacilityMaintainanceUserDetailsObject;
  @Output() nextBtnClickOnStep1: EventEmitter<string | null> = new EventEmitter();
  @Output() step1Values: EventEmitter<object> = new EventEmitter();
  @Output() cancelBtnClickOnStep1: EventEmitter<string> = new EventEmitter();

  // for mobile tooltip
  @ViewChild('tt1', { static: false }) mytooltip1: NgbTooltip;
  @ViewChild('tt2', { static: false }) mytooltip2: NgbTooltip;

  rootScopeData: RootScopeDeclare;
  step1Form: FormGroup;
  submitted = false;
  isCaptchaVerified: boolean;
  showPassword = false;
  showConfirmPassword = false;
  firstNameError: string;
  lastNameError: string;
  emailAlreadyExists = false;
  accountExistsMessage: string | SafeHtml | null | undefined;
  receiveEmail = false;
  optinResearch = false;
  //userEmailGoToStep2: IManagerEmail;

  constructor(
    private rootScopeService: RootScopeService,
    private fb: FormBuilder,
    private commonUtil: CommonUtil,
    private validateManagerEmailService: ValidateManagerEmailService,
    private router: Router,
    private _amplitudeAnalytics: AmplitudeAnalyticsService
  ) {
    this.getRootScopeData();
  }

  ngOnInit() {
    this.step1Form = this.fb.group(
      {
        fname: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z ]*$')])],
        lname: ['', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z ]*$')])],
        email: [
          '',
          Validators.compose([
            Validators.required,
            Validators.pattern(
              /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+[.][A-Za-z]{2,50}$/
            ),
          ]),
        ],
        password: ['', Validators.required],
        confirmPassword: ['', Validators.required],
        receiveEmail: [''],
        optinResearch: ['']
      },
      {
        validator: [
          PasswordPolicy('password'),
          PasswordPolicy('confirmPassword'),
          MustMatch('password', 'confirmPassword'),
        ],
      }
    );
    this.firstNameError = this.commonUtil.replaceValueAsHTMLOnTranslatedText('PLEASE.ENTER', [
      this.commonUtil.translateText('NAME').toLowerCase(),
    ]);
    this.lastNameError = this.commonUtil.replaceValueAsHTMLOnTranslatedText('PLEASE.ENTER', [
      this.commonUtil.translateText('NAME').toLowerCase(),
    ]);
    let anchorText = '<a href="#/login" routerLink="/login">' + this.commonUtil.translateText('LOGIN') + '</a>';
    this.accountExistsMessage = this.commonUtil.replaceValueAsHTMLOnTranslatedText('ALREADY.EXISTS.LOGIN.MSG', [
      anchorText,
    ]);
    this.step1Form.patchValue({
      receiveEmail: false,
      optinResearch:false
    });
    if (this.userInformation) {
      this.step1Form.patchValue({
        email: this.userInformation.email,
        receiveEmail: this.userInformation.emailNotificationsOK,
        optinResearch: this.userInformation.optinResearch
      });
    }
  }

  public alphabetMatcher(event: KeyboardEvent) {
    const allowedRegex = /[^a-zA-Z\s]/g;

    if (event.key.match(allowedRegex)) {
      event.preventDefault();
    }
  }

  get step1Validator() {
    return this.step1Form.controls;
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => (this.rootScopeData = rootScopeData));
  }

  onCaptchaStatusChange(status: string): void {
    if (status === 'success') {
      this.onCaptchaSuccess();
    } else {
      this.onCaptchaFail();
    }
  }

  onCaptchaSuccess(): void {
    this.isCaptchaVerified = true;
  }

  onCaptchaFail(): void {
    this.isCaptchaVerified = false;
  }

  validateSignupStep1(): void {
    alert('parent component - next');
  }

  emitStep1FieldValuesToParentComponent(): void {
    const step1Data: object = {
      user: {
        email: this.step1Form.value.email.toString().toLowerCase(),
        password: btoa(unescape(encodeURIComponent(this.step1Form.value.password))),
        preferredLanguage: this.rootScopeData.selectedLang,
        emailNotificationsOK: this.step1Form.value.receiveEmail,
        optinResearch: this.step1Form.value.optinResearch,
        firstName: this.step1Form.value.fname,
        lastName: this.step1Form.value.lname,
      },
    };
    this.step1Values.emit(step1Data);
  }

  gotoStep2(): void {
    this.submitted = true;
    if (this.step1Form.invalid) {
      // alert('form failed - Ramesh: ' + JSON.stringify(this.step1Form.value, null, 4));
      return;
    }

    this.validateManagerEmailService
      .validateManagerEmail({email: this.step1Form.value.email.toString().toLowerCase()})
      .subscribe(
        data => {
          if(data.emailExists === 'true'){
            this.emailAlreadyExists = true;
          }else{
            this.emailAlreadyExists = false;
          }
          if (this.emailAlreadyExists) {
            return;
          } else {
            // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.step1Form.value, null, 4));
            this.emitStep1FieldValuesToParentComponent();
            this.nextBtnClickOnStep1.emit();
          }
        },
        error => {
          console.error('API failed.');
        }
      );

    // display form values on success
  }

  stopPropagation(e: Event) {
    e.stopPropagation();

    if (this.rootScopeData.isRTL) {
      if (this.mytooltip2.isOpen()) {
        this.mytooltip2.close();
      } else {
        this.mytooltip2.open();
      }
    } else {
      if (this.mytooltip1.isOpen()) {
        this.mytooltip1.close();
      } else {
        this.mytooltip1.open();
      }
    }
  }

  cancelSignup(): void {
    if (!this.step1Form.pristine) {
      this.cancelBtnClickOnStep1.emit();
    } else {
      this.router.navigate(['/landing']);
    }
  }

  changeoptinResearchPreference(optinResearchChecked: boolean){
   if(optinResearchChecked===true){  
    this._amplitudeAnalytics.logEvent({elementName: 'Optin Research', action: "Checked"});
    this.receiveEmail=true;
    this.step1Form.value.receiveEmail= true;
   }
  }
  
  changeEmailPreference(emailPrefChecked: boolean){
      this.receiveEmail= emailPrefChecked;
  }
}
